import { call, cancelled, put, select, takeEvery } from 'redux-saga/effects';
import { api } from 'api';
import { getArticle, getRegionCode } from 'common/selectors';
import log from 'loglevel';
import { EffectR } from 'types/utils';
import { FETCH_RELATED_PRODUCTS } from 'features/related-products/actions';
import { FETCH_VARIANTS } from './actions';
import { fetchVariants } from './utils/api';
import { processFetchedResult as processVariants } from './utils/response-processor';

export function* doFetchVariants() {
  const productId = (yield select(getArticle)) as EffectR.Select<typeof getArticle>;
  const regionCode = (yield select(getRegionCode)) as EffectR.Select<typeof getRegionCode>;

  const abortController = (yield call([api, 'abortController'])) as EffectR.Call<
    (typeof api)['abortController']
  >;

  yield put(FETCH_VARIANTS.request());

  try {
    const data = (yield call(
      fetchVariants,
      { productId, regionCode },
      { cancelToken: abortController.token },
    )) as EffectR.Call<typeof fetchVariants>;

    yield put(FETCH_VARIANTS.success(data));
  } catch (e) {
    if (e instanceof Error) {
      yield put(FETCH_VARIANTS.failure(e));
    }
  } finally {
    if ((yield cancelled()) as boolean) {
      abortController.cancel();
      yield call(log.info, 'fetchVariants was cancelled');
      yield put(FETCH_VARIANTS.cancel());
    }
  }
}

export function* variantsSaga() {
  yield takeEvery(FETCH_RELATED_PRODUCTS.success, function* putVariants({ payload }) {
    const productId: string = yield select(getArticle);
    const variantsModel = processVariants(productId)(payload?.variants);
    yield put(FETCH_VARIANTS.success(variantsModel));
  });
}
